import { usePurchaseRegisterCleaner } from '../hooks/purchases/usePurchaseRegisterCleaner';
import { useSaleRegisterCleaner } from '../hooks/sale/useSaleRegisterCleaner';

const RegisterWatchers = () => {
  usePurchaseRegisterCleaner();
  useSaleRegisterCleaner();

  return null;
};

export default RegisterWatchers;
